/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fuzzy_Glad_Guppy_ScoopInputs */

const en_fuzzy_glad_guppy_scoop = /** @type {(inputs: Fuzzy_Glad_Guppy_ScoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as read`)
};

const de_fuzzy_glad_guppy_scoop = /** @type {(inputs: Fuzzy_Glad_Guppy_ScoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als gelesen markieren`)
};

/**
* | output |
* | --- |
* | "Mark as read" |
*
* @param {Fuzzy_Glad_Guppy_ScoopInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fuzzy_glad_guppy_scoop = /** @type {((inputs?: Fuzzy_Glad_Guppy_ScoopInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fuzzy_Glad_Guppy_ScoopInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fuzzy_glad_guppy_scoop(inputs)
	return de_fuzzy_glad_guppy_scoop(inputs)
});